import { EducationModuleInterface } from "./interfaces/education-module.interface";
import { EducationStepInterface } from "./interfaces/education-step.interface";

export class OepModule implements EducationModuleInterface {

    id: string;
    title: string;
    type: string;
    steps!: EducationStepInterface[];

    constructor(id: string, title: string, type: string, steps: EducationStepInterface[]) {
        this.id = id;
        this.title = title;
        this.type = type;
        this.steps = steps;
    }

}